import { render, staticRenderFns } from "./OrderDetailProductTable.vue?vue&type=template&id=2470ece6&scoped=true&"
import script from "./OrderDetailProductTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailProductTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailProductTable.vue?vue&type=style&index=0&id=2470ece6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470ece6",
  null
  
)

export default component.exports